import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import DeleteModal from "components/Common/DeleteModal"
import WarehouseListComponent from "components/Warehouse/list"
import {
  deleteWarehouse,
  getWarehouses,
} from "store/warehouse/warehouse-action"
import UserListComponent from "components/User/list"
import { deleteUser, getUsers } from "store/user/user-action"
import { userAction } from "store/user/user-slice"

const UserList = () => {
  const dispatch = useDispatch()
  const { data, error, loading } = useSelector(state => state.user)
  const [deleteModal, setDeleteModal] = useState(false)
  const [user, setUser] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })

  const handleDeleteFunc = data => {
    if (user) {
      dispatch(deleteUser(user.id))
    }
    setDeleteModal(false)
  }

  const onClickDelete = data => {
    setUser(data)
    setDeleteModal(true)
  }

  const onPageClick = link => {
    dispatch(getUsers(link.url, pageNumber, according, search))
  }

  const onSearchHandler = value => {
    setSearch(value)
  }

  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      dispatch(getUsers(undefined, undefined, undefined, search))
    }, 1500)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  useEffect(() => {
    dispatch(getUsers(undefined, pageNumber, according, search))
  }, [pageNumber, according])

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteFunc}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Breadcrumbs title={"Admin"} breadcrumbItem={"Users"} />
      <UserListComponent
        data={data}
        error={error}
        loading={loading}
        onClickDelete={onClickDelete}
        handleDeleteFunc={handleDeleteFunc}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
      />
    </React.Fragment>
  )
}

export default UserList
